<ng-container *ngIf="to['open'] && !formState['readonly'] && !to['readonly']; else card">
  <formly-field *ngFor="let field of field.fieldGroup" [field]="field"></formly-field>
</ng-container>
<ng-template #card>
  <div class="tpa-wrapper__content">
    <div *ngIf="!model || !(model?.zdravPojistovna !== 0 && model?.zdravPojistovna); else notEmpty">
      <p>
        {{ 'TPA.NotFilled' | transloco }}
      </p>
    </div>
    <ng-template #notEmpty>
      <p>
        <span *ngIf="model?.zdravPojistovna !== 0 && model?.zdravPojistovna">
          {{ model?.zdravPojistovna }}
        </span>
        <span *ngIf="model?.zdravPojistovna === 0">{{
          model?.jinaZdravPojistovna
          }}</span>
        <span *ngIf="model?.cisloPojistence">
          ({{ model?.cisloPojistence }})</span>
      </p>
      <p *ngIf="model?.zdravotniZnevyhodneni">
        {{ 'TPA.HealthDisadvantage' | transloco }}:
        {{ model?.zdravotniZnevyhodneni | healthDisadvantage }}
      </p>
      <p *ngIf="model?.ztpp">
        {{ 'TPA.Ztpp' | transloco }}: {{ model?.ztpp | yesOrNo }}
      </p>
      <p *ngIf="model?.a1">
        {{ 'TPA.A1' | transloco }}: {{ model?.a1 | yesOrNo }}
      </p>
      <p *ngIf="model?.duchody?.pobiramDuchod === true">
        <span>
          {{ 'TPA.Pensions' | transloco }}:
        </span>
        <br>
      </p>

      <p *ngIf="model?.duchody?.starobni?.pobiran === true">

        {{ 'TPA.RetirementPension' | transloco }}: {{ model?.duchody?.starobni?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.starobni?.pobiranDo">
          - {{ model?.duchody?.starobni?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>

        <span *ngIf="model?.duchody?.starobni?.predcasnyStarobniDuchod === true">
          ({{ 'TPA.EarlyRetirementPension' | transloco }})</span>
        <span *ngIf="model?.duchody?.starobni?.starobniDuchodSeSnizenymDuchodovymVekem === true">
          ({{ 'TPA.PensionWithReducedPensionAge' | transloco }})
        </span>
      </p>


      <p *ngIf="model?.duchody?.invalidni?.pobiran === true">
        {{ 'TPA.DisabilityPension' | transloco }}: {{ model?.duchody?.invalidni?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.invalidni?.pobiranDo">
          - {{ model?.duchody?.invalidni?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>
      </p>
      <p *ngIf="model?.duchody?.invalidniTretihoStupne?.pobiran === true">
        {{ 'TPA.PensionWithInvalidityThree' | transloco }}: {{ model?.duchody?.invalidniTretihoStupne?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.invalidniTretihoStupne?.pobiranDo">
          - {{ model?.duchody?.invalidniTretihoStupne?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>
      </p>
      <p *ngIf="model?.duchody?.starobniZahranicni?.pobiran === true">
        {{ 'TPA.PensionWithStarobnialPensionAbroad' | transloco }}:
        : {{ model?.duchody?.starobniZahranicni?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.starobniZahranicni?.pobiranDo">
          - {{ model?.duchody?.starobniZahranicni?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>
        <span *ngIf="model?.duchody?.starobniZahranicni?.predcasnyStarobniDuchod === true">
          ({{ 'TPA.EarlyRetirementPension' | transloco }})
        </span>
      </p>


      <p *ngIf="model?.duchody?.invalidniZahranicni?.pobiran === true">
        {{ 'TPA.PensionWithInvalidityOneTwoAbroad' | transloco }}: {{ model?.duchody?.invalidniZahranicni?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.invalidniZahranicni?.pobiranDo">
          - {{ model?.duchody?.invalidniZahranicni?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>
      </p>


      <p *ngIf="model?.duchody?.invalidniZahranicniTretihoStupne?.pobiran === true">
        {{ 'TPA.PensionWithInvalidityThreeAbroad' | transloco }}: {{
        model?.duchody?.invalidniZahranicniTretihoStupne?.pobiranOd |
        translocoDate: { dateStyle: 'medium' } }}
        <span *ngIf="model?.duchody?.invalidniZahranicniTretihoStupne?.pobiranDo">
          - {{ model?.duchody?.invalidniZahranicniTretihoStupne?.pobiranDo | translocoDate: {
          dateStyle: 'medium' } }}
        </span>
      </p>

      <p *ngIf="model?.duchody?.jiny?.pobiran === true">
        {{ 'TPA.OtherPension' | transloco }}: {{ model?.duchody?.jiny.nazevDuchodu }}
      </p>
    </ng-template>
  </div>
</ng-template>